import * as types from "../../redux/types";
import backend from "../../api/api";
import { store } from "../../redux/store";

const getConfig = () => {
  const token = store.getState().auth.token;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  return config;
};

export const createAttribute = (formValues) => async (dispatch) => {
  formValues["data"] = "";
  try {
    const response = await backend.post(
      "api/wholesale/attribute/",
      { ...formValues },
      getConfig()
    );
    if (response.status === 201) {
      dispatch({
        type: types.CREATE_WHOLESALE_ATTRIBUTE,
        payload: { ...response.data },
      });
      // history.push("/product/attribute");
    }
  } catch (error) {
    console.log(error);
  }
};

export const getAllAttribute = () => async (dispatch) => {
  try {
    const response = await backend.get("api/wholesale/attribute/", getConfig());
    if (response.status === 200) {
      dispatch({
        type: types.GET_ALL_WHOLESALE_ATTRIBUTE,
        payload: response.data,
      });
    }
  } catch (error) {
    console.log(error);
  }
};
export const getAllAttributeTerm = () => async (dispatch) => {
  try {
    const response = await backend.get("api/wholesale/attribute-term/", getConfig());
    if (response.status === 200) {
      dispatch({
        type: types.GET_ALL_WHOLESALE_ATTRIBUTE_TERM,
        payload: response.data,
      });
    }
  } catch (error) {
    console.log(error);
  }
};

export const deleteAttribute = (id) => async (dispatch) => {
  try {
    const response = await backend.delete(
      `api/wholesale/attribute/${id}/`,
      getConfig()
    );
    if (response.status === 204) {
      dispatch({ type: types.DELETE_WHOLESALE_ATTRIBUTE, payload: id });
    }
  } catch (error) {
    console.log(error);
  }
};

export const updateAttribute = (id, formValues) => async (dispatch) => {
  try {
    const response = await backend.patch(
      `api/wholesale/attribute/${id}/`,
      formValues,
      getConfig()
    );
    if (response.status === 200) {
      dispatch({ type: types.UPDATE_WHOLESALE_ATTRIBUTE, payload: { ...response.data } });
    }
  } catch (error) {
    console.log(error.response);
  }
};

export const createAttributeTerm =
  (formValues, attributeid) => async (dispatch) => {
    formValues["data"] = "";
    formValues.Attribute = attributeid;
    try {
      const response = await backend.post(
        "api/wholesale/attribute-term/",
        { ...formValues },
        getConfig()
      );
      if (response.status === 201) {
        dispatch({
          type: types.CREATE_WHOLESALE_ATTRIBUTE_TERM,
          payload: { ...response.data },
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
export const deleteAttributeTerm = (id) => async (dispatch) => {
  try {
    const response = await backend.delete(
      `api/wholesale/attribute-term/${id}/`,
      getConfig()
    );
    if (response.status === 204) {
      dispatch({ type: types.DELETE_WHOLESALE_ATTRIBUTE_TERM, payload: id });
    }
  } catch (error) {
    console.log(error);
  }
};

export const updateAttributeTerm = (id, formValues) => async (dispatch) => {
  try {
    const response = await backend.patch(
      `api/wholesale/attribute-term/${id}/`,
      formValues,
      getConfig()
    );
    if (response.status === 200) {
      dispatch({
        type: types.UPDATE_WHOLESALE_ATTRIBUTE_TERM,
        payload: { ...response.data },
      });
    }
  } catch (error) {
    console.log(error.response);
  }
};
